function getWxToken () {
  let wxToken = ''
  const searchUrl = window.location.search
  const searchStr = searchUrl.slice(1)
  let searchArray = searchStr.split('&')
  for (const item of searchArray) {
    if (item.indexOf('wx_token') !== -1) {
      const wxTokenArray = item.split('=')
      wxToken = wxTokenArray[1]
      break
    }
  }
  return wxToken
}

export {getWxToken}



// WEBPACK FOOTER //
// ./src/common/util/getWxToken.js